"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageBox = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ImageBox = (props)=>{
    var _module_backgroundImage;
    const { className, module, imageParams, sizes, width, height, id } = props;
    const { getTestId } = (0, _testidGenerator.default)();
    const { palette } = (0, _mui.useTheme)();
    var _module_backgroundImage_url;
    const imageUrl = (_module_backgroundImage_url = module === null || module === void 0 ? void 0 : (_module_backgroundImage = module.backgroundImage) === null || _module_backgroundImage === void 0 ? void 0 : _module_backgroundImage.url) !== null && _module_backgroundImage_url !== void 0 ? _module_backgroundImage_url : '';
    const imagesVariants = (0, _react.useMemo)(()=>imageUrl ? {
            url: imageUrl,
            imageSizeMultiplier: 2,
            backgroundColor: palette.common.white,
            imageFormat: 'WebP',
            params: imageParams !== null && imageParams !== void 0 ? imageParams : []
        } : null, [
        imageParams,
        imageUrl,
        palette.common.white
    ]);
    if (module == null) {
        return null;
    }
    const { content, backgroundImage } = module;
    if (!backgroundImage || width === 0 || height === 0) {
        return null;
    }
    var _content_title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        "data-testid": getTestId(id !== null && id !== void 0 ? id : _constants.IMAGE_BOX),
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            alt: (_content_title = content === null || content === void 0 ? void 0 : content.title) !== null && _content_title !== void 0 ? _content_title : '',
            srcSet: imageParams && imagesVariants ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)) : imageUrl,
            sizes: sizes,
            "data-testid": getTestId(_constants.BACKGROUND_IMAGE)
        })
    });
};
exports.ImageBox = ImageBox;
